import * as React from "react";
import { ExtraIconPro } from "../../../services/product";
import { RightTopTag, LeftTopTag, LeftBottomTag } from "./styles";

interface ProductImageTagViewsProps {
	columnNum: number;
	rightTopTag?: ExtraIconPro;
	leftTopTag?: ExtraIconPro;
	leftBottomTag?: ExtraIconPro;
}

export const ProductImageTagViews = (props: ProductImageTagViewsProps) => {
	const { columnNum, rightTopTag, leftTopTag, leftBottomTag } = props;
	const getStyle = (item: ExtraIconPro) => {
		return { height: item?.height || "auto" };
	};
	return (
		<div>
			{rightTopTag?.img && (
				<RightTopTag
					gridCol={columnNum}
					src={rightTopTag?.img}
					style={getStyle(rightTopTag)}
				/>
			)}
			{leftTopTag?.img && (
				<LeftTopTag
					gridCol={columnNum}
					src={leftTopTag?.img}
					style={getStyle(leftTopTag)}
				/>
			)}
			{leftBottomTag?.img && <LeftBottomTag src={leftBottomTag?.img} />}
		</div>
	);
};
